import localizedPages from './seoLocalizedPages.json';

export const SEO_LANGUAGES = ['en', 'nl', 'de', 'fr', 'es', 'it', 'pt', 'hi'] as const;
export type SeoLanguage = typeof SEO_LANGUAGES[number];
export type PublicSeoSection = 'home' | 'about' | 'faq';

const isSeoLanguage = (value: string): value is SeoLanguage =>
  SEO_LANGUAGES.some((language) => language === value);

export function publicLocaleFromPath(pathname: string): SeoLanguage | null {
  const [language, section, extra] = pathname.split('/').filter(Boolean);
  if (!language || !isSeoLanguage(language) || language === 'en' || extra) return null;
  return !section || section === 'about' || section === 'faq' ? language : null;
}

export function localizedPublicPath(language: string, section: PublicSeoSection): string {
  const suffix = section === 'home' ? '' : `/${section}`;
  return language === 'en' || !isSeoLanguage(language) ? suffix || '/' : `/${language}${suffix}`;
}

export function publicSeoAlternates(section: PublicSeoSection) {
  const entries = SEO_LANGUAGES.map((language) => [language, localizedPublicPath(language, section)]);
  return Object.fromEntries([...entries, ['x-default', localizedPublicPath('en', section)]]) as Record<SeoLanguage | 'x-default', string>;
}

export function localizedSeoPage(language: string, section: PublicSeoSection) {
  if (language === 'en' || !(language in localizedPages)) return null;
  return localizedPages[language as keyof typeof localizedPages][section];
}
